import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { DrawerActions } from '@react-navigation/native';
import { theme } from '../constants/theme';

interface ScreenHeaderProps {
    title: string;
    showDrawer?: boolean;
    showBackButton?: boolean;
    onBackPress?: () => void;
    navigation?: any;
    leftIcon?: {
        name: string;
        onPress: () => void;
    };
    rightIcon?: {
        name: string;
        onPress: () => void;
    };
}

export const ScreenHeader: React.FC<ScreenHeaderProps> = ({
    title,
    showDrawer = false,
    showBackButton = false,
    onBackPress,
    navigation,
    leftIcon,
    rightIcon,
}) => {
    const handleBackPress = () => {
        if (onBackPress) {
            onBackPress();
        } else if (navigation) {
            navigation.goBack();
        }
    };

    const handleDrawerPress = () => {
        if (navigation) {
            navigation.dispatch(DrawerActions.openDrawer());
        }
    };

    return (
        <View style={styles.header}>
            {/* Left Section */}
            <View style={styles.leftSection}>
                {showDrawer && (
                    <TouchableOpacity
                        style={styles.iconButton}
                        onPress={handleDrawerPress}
                    >
                        <Icon name="menu" size={24} color="#fff" />
                    </TouchableOpacity>
                )}
                {showBackButton && (
                    <TouchableOpacity
                        style={styles.iconButton}
                        onPress={handleBackPress}
                    >
                        <Icon name="arrow-left" size={24} color="#fff" />
                    </TouchableOpacity>
                )}
                {leftIcon && (
                    <TouchableOpacity
                        style={styles.iconButton}
                        onPress={leftIcon.onPress}
                    >
                        <Icon name={leftIcon.name} size={24} color="#fff" />
                    </TouchableOpacity>
                )}
                {!showDrawer && !showBackButton && !leftIcon && (
                    <View style={styles.iconButton} />
                )}
            </View>

            {/* Title */}
            <Text style={styles.title} numberOfLines={1}>
                {title}
            </Text>

            {/* Right Section */}
            <View style={styles.rightSection}>
                {rightIcon ? (
                    <TouchableOpacity
                        style={styles.iconButton}
                        onPress={rightIcon.onPress}
                    >
                        <Icon name={rightIcon.name} size={24} color="#fff" />
                    </TouchableOpacity>
                ) : (
                    <View style={styles.iconButton} />
                )}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: 60,
        paddingVertical: theme.spacing.sm,
        paddingHorizontal: theme.spacing.md,
        backgroundColor: theme.colors.primary,
        ...theme.shadows.sm,
    },
    leftSection: {
        width: 40,
        alignItems: 'flex-start',
    },
    rightSection: {
        width: 40,
        alignItems: 'flex-end',
    },
    iconButton: {
        // padding: 8,
        paddingHorizontal: 4,
    },
    title: {
        ...theme.typography.h5,
        color: '#fff',
        fontWeight: '700',
        textAlign: 'center',
        flex: 1,
    },
});
